import { CheckIcon } from 'lucide-react'

export const OAuthSuccess = () => (
  <>
    <div className="mt-auto w-min rounded-full border-2 border-grass-8 bg-grass-2 p-6">
      <CheckIcon className="h-16 w-16 text-grass-10" />
    </div>
    <span className="mt-6 text-lg text-gray-11">Authentication successful!</span>
  </>
)
